export default __webpack_public_path__ + "static/media/11.f024f467.png";